import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  MutationCancelEmailUpdateArgs,
  Action,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getAuthTokenKey,
  getAuthMemberKey,
} from '../../utils/keys/authToken.keys.js'
import { getMembersKey } from '../../utils/keys/member.key.js'

export const useCancelEmailUpdate = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationCancelEmailUpdateArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationCancelEmailUpdateArgs>(
    input => client.members.cancelEmailUpdate(input),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getMembersKey())
        queryClient.invalidateQueries(getAuthTokenKey())
        queryClient.invalidateQueries(getAuthMemberKey())
      },
      ...useMutationOptions,
    },
  )
}
